<template>
  <v-card class="json-pretty-print tools-view-card">
    <ToolbarHeader :name="'JSON Pretty Print'"/>
    <v-container>
      <section class="ma-5">
        <v-row>
          <v-col cols="12"
                 sm="12"
                 md="12">
            <label>
              JSON
            </label>
            <editor
                v-model="form.json"
                @init="initJSONEditor"
                lang="javascript"
                theme="chrome"
                id="json-pretty-print_editor"
                width="100%"
                height="60vh">
            </editor>
          </v-col>
        </v-row>
        <v-btn
            @click="parseAndStringifyJSON"
            color="primary"
        >
          Validate
        </v-btn>
        <v-btn
            class="ml-3"
            @click="minifyJSON"
            color="primary"
        >
          Minify
        </v-btn>
        <v-row v-if="json.error"
               class="justify-center">
          <v-col cols="12"
                 sm="12"
                 md="12">
            <v-alert
                type="error">
              {{ json.error }}
            </v-alert>
          </v-col>
        </v-row>
      </section>
    </v-container>
  </v-card>
</template>
<script>
import ToolbarHeader from "@/components/Toolbar-Header";
import {aceEditorMixin} from "@/mixins/aceEditorMixin";

const form = {
  json: '{"status":200,"error":"","data":[{"news_id":51184,"title":"iPhone X Review: Innovative future with real black technology","source":"Netease phone"},{"news_id":51183,"title":"Traffic paradise: How to design streets for people and unmanned vehicles in the future?","source":"Netease smart"},{"news_id":51182,"title":"Teslamask\'s American Business Relations: The government does not pay billions to build factories","source":"AI Finance","members":["Daniel","Mike","John"]},{"news_id":51182,"title":"Teslamask\'s American Business Relations: The government does not pay billions to build factories","source":"AI Finance","members":["Daniel","Mike","John"]}, {"news_id":51182,"title":"Teslamask\'s American Business Relations: The government does not pay billions to build factories","source":"AI Finance","members":["Daniel","Mike","John"]}, {"news_id":51182,"title":"Teslamask\'s American Business Relations: The government does not pay billions to build factories","source":"AI Finance","members":["Daniel","Mike","John"]}, {"news_id":51182,"title":"Teslamask\'s American Business Relations: The government does not pay billions to build factories","source":"AI Finance","members":["Daniel","Mike","John"]}, {"news_id":51182,"title":"Teslamask\'s American Business Relations: The government does not pay billions to build factories","source":"AI Finance","members":["Daniel","Mike","John"]}]}',
};


export default {
  name: 'JSON-Pretty-Print',
  mixins: [aceEditorMixin],
  components: {
    ToolbarHeader
  },
  mounted() {
    scroll(0, 0);
  },
  data: () => ({
    form: Object.assign({}, form),
    json: {
      error: ''
    }
  }),
  computed: {},
  methods: {
    parseAndStringifyJSON() {
      try {
        if (!this.form.json) {
          return;
        }
        const json = JSON.parse(this.form.json);
        this.form.json = JSON.stringify(json, undefined, 4);
        this.json.error = '';
      } catch (error) {
        this.json.error = error;
        throw new Error(error);
      }

    },
    minifyJSON() {
      try {
        if (!this.form.json) {
          return
        }

        this.form.json = JSON.stringify(JSON.parse(this.form.json));
        this.json.error = '';
      } catch (error) {
        this.json.error = error;
        throw new Error(error);
      }
    },
  }
}
</script>
